import { render, staticRenderFns } from "./StudyResWorksheet.vue?vue&type=template&id=3c12d5c4&scoped=true&"
import script from "./StudyResWorksheet.vue?vue&type=script&lang=js&"
export * from "./StudyResWorksheet.vue?vue&type=script&lang=js&"
import style0 from "./StudyResWorksheet.vue?vue&type=style&index=0&id=3c12d5c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c12d5c4",
  null
  
)

export default component.exports